import ImageLoader from "../classes/ImageLoader";

$(document).ready(function () {
    ImageLoader.preloadDefaultImages();
});